module.exports = __webpack_public_path__ + "img/gzh.ae65a434.png";